export function isEncodedURL(url: string): boolean {
	return !url.includes('/');
}
